export const RECEIVED_ATLAS_INSTALLER_VERSIONS =
  'RECEIVED_ATLAS_INSTALLER_VERSIONS';
export const RECEIVED_ATLAS_DOCKER_VERSIONS = 'RECEIVED_ATLAS_DOCKER_VERSIONS';
export const ATLAS_DATA_INFO_LOAD = 'ATLAS_DATA_INFO_LOAD';
export const ATLAS_ENV = 'ATLAS_ENV';
export const LOADING_START = 'LOADING_START';
export const LOADING_STOP = 'LOADING_STOP';
export const USER_REAUTH = 'USER_REAUTH';
export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';
export const SET_ACTIVE_USER = 'SET_ACTIVE_USER';
export const RECEIVED_LICENSE_KEY = 'RECEIVED_LICENSE_KEY';
export const FAILED_TO_FETCH_LICENSE_KEY = 'FAILED_TO_FETCH_LICENSE_KEY';
export const USER_LOADED = 'USER_LOADED';
export const RECEIVED_KUBERNETES_VERSIONS = 'RECEIVED_KUBERNETES_VERSIONS';
